import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCTqmLdNX9RZ4XiFIDhkQvVWdlA4GOX6V8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "unsubscribeglobal-e75ba.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "unsubscribeglobal-e75ba",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "unsubscribeglobal-e75ba.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "970570400228",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:970570400228:web:4313c1bf1ef7da26ea47f1",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

if (firebaseConfig.measurementId && typeof window !== "undefined") {
  getAnalytics(firebaseApp);
}

export const auth = getAuth(firebaseApp);
export const functions = getFunctions(firebaseApp, "us-central1");
export default firebaseApp;
